// extracted by mini-css-extract-plugin
module.exports = {"bottom":"Footer_bottom__KgOmB","container":"Footer_container__hU3RI","grid":"Footer_grid__k1DaB","top":"Footer_top__lMkk3"};